(function (window) {
  'use strict';

  // Loaded before analytics: invitation material must leave the URL immediately.
  if (window.TodayMerchPortalAccess) return;
  var STORAGE_KEY = 'todaymerch-portal-invitation:v1';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;
  var PORTAL_ROUTE = 'pages/espace-client';
  var LOCALE_ROOT_PATTERN = /^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/?)?$/i;
  var pending = null;
  var captureError = '';
  var expiryTimer = null;
  var bootstraps = new WeakMap();
  var customerAuthConfig = null;
  var customerAuthInit = null;
  var customerAuthView = null;

  function customerAuth() {
    var auth = window.TodayMerchCustomerAuth;
    return auth && typeof auth === 'object' ? auth : null;
  }

  function normalizeCustomerAuthConfig(value) {
    return value && typeof value === 'object' && value.enabled === true ? { enabled: true } : { enabled: false };
  }

  async function initCustomerAuth() {
    var auth = customerAuth();
    if (!auth || typeof auth.init !== 'function') { customerAuthConfig = { enabled: false }; return customerAuthConfig; }
    if (!customerAuthInit) {
      customerAuthInit = Promise.resolve().then(function () { return auth.init(); })
        .then(function (config) { customerAuthConfig = normalizeCustomerAuthConfig(config); return customerAuthConfig; })
        .catch(function () { customerAuthConfig = { enabled: false }; return customerAuthConfig; });
    }
    return customerAuthInit;
  }

  function customerAuthEnabled() {
    return customerAuthConfig?.enabled === true && !!customerAuth();
  }

  async function authToken() {
    var config = await initCustomerAuth();
    var auth = customerAuth();
    if (config.enabled !== true || !auth || typeof auth.getAccessToken !== 'function') return '';
    return auth.getAccessToken();
  }

  function invalidateCustomerAuth() {
    var auth = customerAuth();
    if (auth && typeof auth.invalidate === 'function') auth.invalidate();
  }

  function attachAuth(api) {
    if (api && typeof api.setAccessTokenProvider === 'function') api.setAccessTokenProvider(authToken, invalidateCustomerAuth);
  }

  function portalPath() {
    var section = window.document?.querySelector?.('[data-b2b-portal]');
    var localeRoot = section?.dataset.localeRoot || window.Shopify?.routes?.root;
    if (typeof localeRoot !== 'string' || !LOCALE_ROOT_PATTERN.test(localeRoot)) {
      var localizedPath = String(window.location?.pathname || '').match(/^\/([a-z]{2,3}(?:-[a-z0-9]{2,8})*)\/(?:pages|account)(?:\/|$)/i);
      localeRoot = localizedPath ? '/' + localizedPath[1] + '/' : '/';
    }
    if (!localeRoot.endsWith('/')) localeRoot += '/';
    // The native page URL includes Shopify's localized handle, when one exists.
    var pageUrl = section?.dataset.accountUrl;
    if (typeof pageUrl === 'string' && pageUrl.startsWith(localeRoot + 'pages/')) {
      var slug = pageUrl.slice((localeRoot + 'pages/').length);
      try {
        var decodedSlug = decodeURIComponent(slug);
        if (/^(?:[a-z0-9_-]|%[a-f0-9]{2})+$/i.test(slug) && decodedSlug
          && !/[\u0000-\u0020\u007f/\\?#:]/.test(decodedSlug) && !decodedSlug.includes('..')) return pageUrl;
      } catch (error) { /* use the locale-aware portal route below */ }
    }
    return localeRoot + PORTAL_ROUTE;
  }

  function accessError(code) {
    var error = new Error('portal_access_unavailable');
    error.code = code;
    error.portal_access_error = true;
    return error;
  }

  function clear() {
    pending = null;
    captureError = '';
    if (expiryTimer !== null) window.clearTimeout?.(expiryTimer);
    expiryTimer = null;
    try { window.sessionStorage?.removeItem(STORAGE_KEY); } catch (error) { /* memory is still cleared */ }
  }

  function scheduleExpiry() {
    if (expiryTimer !== null) window.clearTimeout?.(expiryTimer);
    if (pending && typeof window.setTimeout === 'function') {
      expiryTimer = window.setTimeout(function () {
        clear();
        captureError = 'PORTAL_INVITATION_RESUME_EXPIRED';
      }, Math.max(0, pending.expires_at - Date.now()));
    }
  }

  function validRecord(record) {
    return record && Object.keys(record).sort().join(',') === 'expires_at,token,version'
      && record.version === 1 && TOKEN_PATTERN.test(record.token)
      && Number.isSafeInteger(record.expires_at) && record.expires_at <= Date.now() + MAX_AGE_MS;
  }

  function restore() {
    try {
      var raw = window.sessionStorage?.getItem(STORAGE_KEY);
      if (!raw) return;
      var record = JSON.parse(raw);
      if (!validRecord(record)) { clear(); return; }
      if (record.expires_at <= Date.now()) {
        clear();
        captureError = 'PORTAL_INVITATION_RESUME_EXPIRED';
        return;
      }
      pending = record;
      scheduleExpiry();
    } catch (error) { clear(); }
  }

  function capture() {
    var fragment = new URLSearchParams(String(window.location?.hash || '').replace(/^#/, ''));
    var query = new URLSearchParams(String(window.location?.search || ''));
    var hasFragment = fragment.has('invite');
    var hasQuery = query.has('invite');
    if (!hasFragment && !hasQuery) { restore(); return; }
    var tokens = fragment.getAll('invite');
    var token = !hasQuery && tokens.length === 1 ? tokens[0] : '';
    fragment.delete('invite');
    query.delete('invite');
    var cleanSearch = hasQuery ? (query.toString() ? '?' + query.toString() : '') : String(window.location.search || '');
    var cleanHash = hasFragment ? (fragment.toString() ? '#' + fragment.toString() : '') : String(window.location.hash || '');
    var cleanUrl = String(window.location.pathname || portalPath()) + cleanSearch + cleanHash;
    try {
      if (typeof window.history?.replaceState !== 'function') throw new Error('unavailable');
      window.history.replaceState(null, '', cleanUrl);
    } catch (error) {
      clear();
      captureError = 'PORTAL_INVITATION_INVALID';
      window.location.replace?.(cleanUrl);
      return;
    }
    clear();
    if (!TOKEN_PATTERN.test(token)) { captureError = 'PORTAL_INVITATION_INVALID'; return; }
    var record = { version: 1, token: token, expires_at: Date.now() + MAX_AGE_MS };
    try {
      var serialized = JSON.stringify(record);
      window.sessionStorage.setItem(STORAGE_KEY, serialized);
      if (window.sessionStorage.getItem(STORAGE_KEY) !== serialized) throw new Error('unverified');
      pending = record;
      scheduleExpiry();
    } catch (error) {
      clear();
      captureError = 'PORTAL_INVITATION_STORAGE_UNAVAILABLE';
    }
  }

  function loginUrl() {
    // Resolve Shopify locale data after the early fragment capture, without copying URL parameters.
    return '/customer_authentication/login?return_to=' + encodeURIComponent(portalPath());
  }

  function mountCustomerAuth(container, options) {
    options = options || {};
    var auth = customerAuth();
    if (!customerAuthEnabled() || !container || !auth || typeof auth.open !== 'function') return false;
    unmountCustomerAuth();
    var button = window.document.createElement('button');
    button.type = 'button'; button.className = 'tm-auth__button tm-auth__button--primary';
    button.textContent = 'Connexion ou inscription';
    var view = { container: container, button: button, opening: false, completing: false };
    customerAuthView = view;
    view.open = async function () {
      if (customerAuthView !== view || view.opening) return;
      view.opening = true;
      try {
        await auth.open({
          trigger: button, returnTo: options.returnTo || portalPath(),
          onAuthenticated: async function (session) {
            if (customerAuthView !== view) return;
            view.completing = true;
            try { await options.onAuthenticated?.(session); }
            finally { view.completing = false; }
          },
          onError: typeof options.onError === 'function' ? options.onError : function () {},
        });
      } catch (error) { options.onError?.(error); }
      finally { view.opening = false; }
    };
    button.addEventListener('click', view.open);
    container.replaceChildren(button);
    void view.open();
    return true;
  }

  function unmountCustomerAuth() {
    var view = customerAuthView;
    customerAuthView = null;
    if (!view) return;
    view.button.removeEventListener('click', view.open);
    var auth = customerAuth();
    if (view.opening && !view.completing) auth?.close?.();
  }

  async function logout() {
    unmountCustomerAuth();
    clear();
    bootstraps = new WeakMap();
    var auth = customerAuth();
    if (auth && typeof auth.logout === 'function') await auth.logout();
  }

  function hasPendingInvitation() {
    if (pending && pending.expires_at <= Date.now()) {
      clear();
      captureError = 'PORTAL_INVITATION_RESUME_EXPIRED';
    }
    return Boolean(pending);
  }

  function terminalInvitationError(error) {
    return ['INVITATION_EXPIRED', 'INVITATION_ALREADY_USED', 'INVITATION_REVOKED',
      'INVITATION_NOT_FOUND', 'INVITATION_TOKEN_INVALID', 'PORTAL_COMPANY_UNAVAILABLE'].includes(error?.code);
  }

  function bootstrap(api, options) {
    if (!api || typeof api.request !== 'function' || typeof api.mutate !== 'function') {
      return Promise.reject(accessError('PORTAL_UNAVAILABLE'));
    }
    attachAuth(api);
    if (bootstraps.has(api)) return bootstraps.get(api);
    var task = (async function () {
      await initCustomerAuth();
      var hasInvitation = hasPendingInvitation();
      if (captureError) throw accessError(captureError);
      if (hasInvitation) {
        try {
          await api.mutate('/client/v1/invitations/accept', {
            operation: 'invitation.accept', resource: 'invitation', expectedVersion: 0,
            body: { token: pending.token },
          });
          clear();
        } catch (error) {
          if (terminalInvitationError(error)) clear();
          // Authentication, wrong-account and transient failures remain resumable within the original TTL.
          error.invitation_accept_failed = true;
          throw error;
        }
      }
      return api.request('/client/v1/dashboard' + (options?.initialOrders === true ? '?include=initial_orders' : ''));
    })();
    bootstraps.set(api, task);
    task.catch(function () { bootstraps.delete(api); });
    return task;
  }

  function classifyError(error, options) {
    options = options || {};
    var state = '';
    var action = 'contact';
    if (error?.status === 401 || ['AUTHENTICATION_REQUIRED', 'APP_PROXY_INVALID'].includes(error?.code)) {
      state = options.authenticated ? 'session_expired' : 'login'; action = 'login';
    } else if (error?.code === 'INVITATION_EMAIL_MISMATCH') {
      state = 'wrong_account'; action = 'logout';
    } else if (['INVITATION_EXPIRED', 'PORTAL_INVITATION_RESUME_EXPIRED'].includes(error?.code)) {
      state = 'invitation_expired';
    } else if (['INVITATION_ALREADY_USED', 'INVITATION_REVOKED'].includes(error?.code)) {
      state = 'invitation_used'; action = 'portal';
    } else if (['INVITATION_NOT_FOUND', 'INVITATION_TOKEN_INVALID', 'PORTAL_INVITATION_INVALID'].includes(error?.code)) {
      state = 'invitation_invalid';
    } else if (error?.code === 'PORTAL_MEMBERSHIP_REQUIRED') {
      state = 'membership_required';
    } else if (['PORTAL_MEMBERSHIP_AMBIGUOUS', 'PORTAL_CONTEXT_INVALID'].includes(error?.code)) {
      state = 'membership_ambiguous';
    } else if (error?.code === 'PORTAL_COMPANY_UNAVAILABLE') {
      state = 'suspended';
    } else if (error?.code === 'PORTAL_INVITATION_STORAGE_UNAVAILABLE') {
      state = 'storage_unavailable';
    } else if (error?.invitation_accept_failed) {
      state = 'invitation_retry'; action = 'reload';
    } else if ((Number.isInteger(error?.status) && error.status >= 500 && error.status <= 599) || ['PORTAL_UNAVAILABLE', 'PORTAL_RESPONSE_INVALID'].includes(error?.code)) {
      state = 'unavailable'; action = 'reload';
    }
    if (!state) return null;
    return {
      state: state, action: action, titleKey: 'access.' + state + '_title',
      bodyKey: 'access.' + state + '_body', actionKey: 'access.action_' + action,
    };
  }

  capture();
  window.TodayMerchPortalAccess = Object.freeze({
    bootstrap: bootstrap, classifyError: classifyError, loginUrl: loginUrl,
    clear: clear, hasPendingInvitation: hasPendingInvitation,
    initCustomerAuth: initCustomerAuth, isCustomerAuthEnabled: customerAuthEnabled,
    mountCustomerAuth: mountCustomerAuth, unmountCustomerAuth: unmountCustomerAuth, logout: logout,
    getAccessToken: authToken, invalidateCustomerAuth: invalidateCustomerAuth, attachAuth: attachAuth,
    get portalPath() { return portalPath(); },
  });
})(window);
